import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { acceptAllCookies, getCookieConsent, rejectMarketingCookies } from '../lib/tracking';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Delay 1500ms - poza LCP window (~2.5s). Hero renderuje sie jako LCP candidate, nie banner.
    const t = setTimeout(() => {
      if (getCookieConsent() === null) setVisible(true);
    }, 1500);
    const handler = () => setVisible(getCookieConsent() === null);
    window.addEventListener('daien-cookie-reset', handler);
    return () => {
      clearTimeout(t);
      window.removeEventListener('daien-cookie-reset', handler);
    };
  }, []);

  function handleAccept() {
    acceptAllCookies();
    setVisible(false);
  }

  function handleReject() {
    rejectMarketingCookies();
    setVisible(false);
  }

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
          role="dialog"
          aria-labelledby="cookie-banner-title"
          className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-50 bg-surface border border-stroke rounded-2xl shadow-2xl p-5 md:p-6"
        >
          <h2 id="cookie-banner-title" className="text-sm font-semibold text-text-primary mb-2">
            Cookies na daien.pl
          </h2>
          <p className="text-xs text-muted leading-relaxed mb-4">
            Używam cookies analitycznych (GTM) i marketingowych (Meta Pixel) żeby mierzyć ruch z reklam. Niezbędne (motyw, preferencje) są zawsze włączone. Szczegóły w{' '}
            <Link to="/polityka-cookies" className="underline hover:text-text-primary">
              polityce cookies
            </Link>
            .
          </p>
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              onClick={handleAccept}
              className="flex-1 bg-text-primary text-bg px-4 py-2.5 rounded-full text-sm font-medium hover:scale-[1.02] transition-transform"
            >
              Akceptuj wszystkie
            </button>
            <button
              onClick={handleReject}
              className="flex-1 bg-bg border border-stroke text-text-primary px-4 py-2.5 rounded-full text-sm font-medium hover:bg-surface transition-colors"
            >
              Tylko niezbędne
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
